import types from '../types';

export const initialState = [];

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_CLIENTS:
      const clients = action.payload;
      if(action.payload !== null) {
        return clients;
      } else return state;
    default:
      return state;
  }
};
